var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    fillRule: "nonzero",
    d: "M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    d: "M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9725DD",
    d: "M18.526 14.146l-.92 1.375h-6.92a.685.685 0 01-.686-.688c0-.38.31-.687.687-.687h7.839z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061d5",
    d: "M16.379 17.583l-.92 1.375h-4.762a.69.69 0 01-.697-.687c0-.38.31-.688.697-.688h5.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C8C0",
    d: "M14.231 21.02l-.424.637a2.166 2.166 0 00-.229.493l-.031.118-.028.127H10.69a.687.687 0 110-1.374h3.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.841 21.332l4.64-6.72.053.092c.074.114.235.322.538.541.456.329.797.374.797.374l-4.64 6.72a2.558 2.558 0 01-.461.483l-1.373 1.037c-.146.11-.234.054-.193-.14l.372-1.764c.04-.187.156-.46.267-.623zm6.648-8.163c.373.272.407.704.407.704a3.57 3.57 0 01-.314.607l-.28.417-.09-.016a1.714 1.714 0 01-.632-.282c-.35-.255-.628-.687-.628-.687l.28-.418c.106-.158.284-.397.448-.51l.074-.009c.14-.012.456-.01.735.194z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.724182b9c7914f75b55b2e6d0fa363df.svg";
export { ForwardRef as ReactComponent };